import { useContext, useState } from "react";
import styles from "./Stitch.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./Details";
import { BackToMethods } from "../../common/BackToMethods";
import { WalletPayProps } from "../Wallet";
import axios from "axios";
import Loader from "../../common/Loader";
import { makeid, sendMessage } from "../../../context/utils";
import { ErrorAlertContext } from "../../../context/ErrorAlert";

export const StitchMethod = () => {
  const { email, currency, amount, merchantKey, payData } =
    useContext(RoutingContext);
  const { onShowAlert } = useContext(ErrorAlertContext);

  const [isLoading, setIsLoading] = useState(false);

  const onContinue = async (data?: WalletPayProps) => {
    var stitchRefId = "ST_" + makeid();

    const stitchObj = {
      amount,
      email: payData.kit?.email,
      phoneNumber: payData.kit?.phone_number,
      paymentType: payData.kit?.paymentType,
      currency: payData?.currency,
      firstName: data?.firstName,
      lastName: data?.Name,
      accountNumber: "1234567890",
      bankId: "absa",
      accountName: "stitchAccName",
      tx_ref: stitchRefId,
      sourceCurrency: payData?.sourceCurrency,
      sourceAmount: payData.kit?.sourceAmount,
    };

    if (
      payData.kit.extra &&
      ["baepay", "baepayapp"].includes(payData.kit.extra)
    ) {
      // @ts-ignore
      stitchObj.extra = "baepay";
      // @ts-ignore
      stitchObj.baeEmail = payData?.kit?.baeEmail;
    }

    try {
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}pay/stitch/payment/request`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": merchantKey,
        },
        data: stitchObj,
      });
      const responseData = response.data;

      if (responseData["data"]) {
        if (responseData["data"]["__typename"] === "Mutation") {
          const stitchDataUrl =
            responseData.data.clientPaymentInitiationRequestCreate
              .paymentInitiationRequest.url;
          const stitchRedirectUrl =
            stitchDataUrl +
            "/?redirect_uri=https://stitch-redirect.herokuapp.com/";
          responseData.status = "pending";
          setTimeout(() => {
            sendMessage(data);
          }, 5000);
          window.location.replace(stitchRedirectUrl);
        }
      } else if (responseData.errors) {
        onShowAlert(responseData, responseData.errors[0].message);
      } else {
        onShowAlert(responseData, "Payment failed please try again");
      }
      setIsLoading(false);
    } catch (error) {
      onShowAlert(error, "Payment failed please try again");
      setIsLoading(false);
    }
  };
  return (
    <MobileWrapper>
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={currency} />
          <div className={styles.body}>
            <Details onContinue={onContinue} isLoading={isLoading} />
          </div>
          <BackToMethods />
        </div>

        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
